import { h, Fragment } from "preact";
import { Card, Typography } from "antd";
import ReportsSection from './ReportsSection';


export default function ManualReviewPage(props) {

    return (
        <>
            <Card
                bordered={false}
                title={
                    <Typography.Title level={4}>
                        Page is in progress
                    </Typography.Title>
                }
            >
            </Card>
            <Card
                bordered={false}
                title={
                    <Typography.Title level={4}>
                        Detailed Report
                    </Typography.Title>
                }
            >
                <ReportsSection/>
            </Card>
        </>
    );
}
